module.exports = __webpack_public_path__ + "static/media/user-icon-active.59cc87ad.svg";